import React from 'react';
import OthersUserfeedList from '../userfeeds/others_userfeed_list';

const FeedList = ({ currentUser, hashedCompanyId = null, companyId = null, circleId = null }) => {
  return (
    <React.Fragment>
      {OthersUserfeedList({ currentUser, companyId, hashedCompanyId, circleId })}
    </React.Fragment>
  );
};

export default FeedList;
